// extracted by mini-css-extract-plugin
export var navHolder = "Nav-module--navHolder--dbf66";